import styled from "styled-components";

export const MenuClienteCSS = styled.div`

  #menu-cliente{
    width:100%; 
    float:left; 
    position:fixed; 
    z-index: 5;
    border-bottom: 1px solid #dadce0;
    top: 0;
    left: 0;
    background: #043c54;
    box-shadow: 0px 5px 10px #00000029;
    text-align: center;
    padding: 10px 20px;

    
  }

  .nav-item.ativo a{
      color: #e49d04;
  }

  .modoco{
      right: 0!important;
      min-height: 44%!important;
      height: 44%!important;
      top: 9%!important;
      left: 70%!important;
      width: 30%!important;
      min-width: 565px;
  }

  .modalscript{
      right: 0!important;
      min-height: 45%!important;
      height: 45%!important;
      top: 54%!important;
      left: 70%!important;
      width: 30%!important;
      min-width: 565px;
      z-index: 1050
  }

  .links{
    width: 14%;
    /* border-right: 1px solid #dadce0; */
    text-align: center;
    color: #FFF;
    cursor: pointer;
    transition: 0.5s;
    display: inline-block;

    @media(max-width: 500px){
      width: 20%;
    }
  }

  .links:last-child{
    border-right: none;
  }

  .links small{
    float: left;
    width: 100%;
    font-size: 12px;
  }

  .links svg{
    color: #FFF;
    font-size: 22px;
    opacity: 0.8;
    transition: 0.5s;
  }

  .links svg:hover{  
    opacity: 1.0;
    transition: 0.5s
  }

  .links:hover {
    background: #fff;
    transition: 0.5s;
    border-radius: 4px;

    small {
      color: #043c54;
    }

    svg {
      color: #043c54;

    }
  }

  .links:hover .sublink{
    display: block;
    background: #fff;
  }

  .sublink{
    background: #fff;
    text-align: left;
    position: absolute;
    width: 100%;
    top: 90%;
    display:none;
    padding: 10px 25px;
  }

  .sublink a{
    color: #333;
    padding: 10px 0;
    float: left;
    width: 100%;
    font-size: 14px;
  }

  table.table a{
    font-weight: bold;
  }

  .sublink ul{
    list-style-type: none;
    padding: 0
  }

  .icomodal{
    max-width: 40px;
  }

  .input-group-lg>.custom-select, .input-group-lg>.input-group-prepend>.input-group-text{
      font-size: 13px!important;
    }

/*==========acordeonn============*/
    .acord{
      float:left;
      width: 100%;
      padding: 10px 20px;
      border: 1px #ddd solid;
      cursor: pointer;
    }

    .escolhas{
      float:  left;
      width: 100%;
      padding: 15px;
      font-size: 12px;
    }

    #lista{
      float: left;
      width: 40%;
      height: 100px;
      padding: 10px;
      position: relative
    }

    #lista a.btn.btn-primary, #lista a.btn.btn-warning  {
      color: #fff;
      padding: 5px 20px;
      font-size: 10px;
      margin: 0 10px
    }

    table.table th, table.table td {
      padding-top: 2%;
      padding-bottom: 2%; 
    }

    .contscript{
      float: left;
      width: 60%;
      height: 350px;
      padding: 1%;
      background: #f4f4f4;
      overflow: auto;
      border-radius: 5px;
      border: 1px #ddd solid;
    }

    .fecha{
      position: absolute;
      top: 10px;
      right: 10px;
      opacity: 0.3;
      width: 15px;
      cursor: pointer;
    }

  .react-draggable{
      display: none;
      width: 50%;
      border: 1px solid #dadce0;
      box-shadow: 0px 5px 15px #00000029;
      border-radius: 5px;
      background: #f6f6f6;
      padding: 1% 2%;
      position: absolute;
      height:450px;
      z-index: 200;
      top: 20%;
      left: 20%;
      overflow: auto
    }

    
    .react-draggable, .cursor {
      cursor: move;
    }

    .no-cursor {
      cursor: auto;
    }

  
    .react-draggable section{
      height: 100%;
      overflow: auto
    }

    .react-draggable h2{
      font-size: 16px;
    }

    .user{
    position: absolute;
    width:100px;
    font-size: 11px;
    text-align: center;

    img{
      width: 30px
      }
    }

    .usr{
      top: 5px;
      left: 5px;
    }

  .ballon{
    float: right;
    width: 96%;
    padding: 20px;
    position: relative;
    border: 1px #c9c9c8 solid;
    border-radius: 5px;		
    color: #333;
    margin: 0 2% 2% 0;

    p{
      padding-left: 12%
    }
    
  }

  .usuario{
    background: #faf9f7;
  }

  .atendente{
    background: #ebeae8;
    border: 1px #ad96f9 solid;
  }
  .atd{
    top:-10px;
    right: -20px;
  }

  @media only screen and (max-width: 1366px) {

    .links img{
      opacity: 0.8;
      transition: 0.5s;
      width: 40px;
    }

    .modoco{
      top: 11%!important;
      left: 70%!important;
      width: 30%!important;
      min-width: 400px;
  }

  .modalscript{
      left: 70%!important;
      width: 30%!important;
      min-width: 400px;
  }

  #lista{
    height:60px;
  }

  #lista .contscript{
    width: 100%;
    height: 350px
  }

  .table-responsive{
        height: 200px!important;
    }

  .react-draggable{
      width: 80%;
      top: 15%;
      left: 10%;
    }


  #fullballon{
    float: left;
    width: 100%;
    height: 350px;
    overflow: auto;
    padding: 30px;
  }



  }


  @media only screen and (max-width: 1280px) {
  
    }

  @media only screen and (max-width: 1024px) {


  }


`;